import { useMemo } from 'react';

import { useGetCart } from '@/components/app/cart/services/hooks';
import { useCheckoutStore } from '@/store/checkout.store';

export function useFinalPrice() {
  const { data } = useGetCart();
  const { useWallet } = useCheckoutStore();

  return useMemo(() => {
    if (!data) return 0;
    const { total = 0, subtotal = 0, wallet = { total: 0 } } = data;
    const walletTotal = wallet?.total || 0;
    const final = useWallet ? total - subtotal - walletTotal : total - subtotal;
    return final < 0 ? 0 : final;
  }, [data, useWallet]);
}

